module.exports = __webpack_public_path__ + "img/zuoye.07dbdd97.png";